/**
 * Einstellung „Ton“ der Kasse (K8): je Gerät, im lokalen Speicher. Ohne Speicher (privates Fenster, gesperrt) gilt der
 * Standard „an“; jeder Zugriff ist abgesichert, die Kasse darf daran nie scheitern.
 */
export const SOUND_KEY = 'barso.pos.sound';

/**
 * Wahl, die sich nicht speichern ließ: gilt bis zum Neuladen. Ohne sie läse `beep` (über `readSound`) wieder den Standard
 * „an“, und der Schalter „Ton aus“ wirkte bei gesperrtem Speicher gar nicht.
 */
let unsaved: boolean | null = null;

/** Ton an? Standard an; nur ein ausdrücklich gespeichertes „off“ schaltet ihn aus. */
export function readSound(): boolean {
  if (unsaved !== null) return unsaved;
  try {
    return localStorage.getItem(SOUND_KEY) !== 'off';
  } catch {
    return true;
  }
}

/** Merkt die Wahl. Gelingt das Speichern nicht, gilt sie bis zum Neuladen der Seite. */
export function writeSound(on: boolean): void {
  try {
    localStorage.setItem(SOUND_KEY, on ? 'on' : 'off');
    unsaved = null;
  } catch {
    unsaved = on;
  }
}
